export const supportUrl = 'https://branch-direct.zendesk.com/hc/en-us'
export const supportRequestUrl =
  'https://support.branchapp.com/hc/en-us/requests/new'
export const failedAdvanceArticleUrl =
  'https://branch-direct.zendesk.com/hc/en-us/articles/37304832695835-Why-did-my-advance-to-my-external-card-Branch-Wallet-fail'
export const advanceDelaysArticleUrl =
  'https://branch-direct.zendesk.com/hc/en-us/articles/37304486024603-Why-are-advances-to-my-connected-external-card-delayed'
export const eDeliveryConsentSupportUrl =
  'https://support.branchapp.com/hc/en-us/articles/43534941333019-E-Delivery-Consent-Updates'
